'use client'

import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { ChartData } from './types'

interface LineHighChartProps {
  data: ChartData
  isUpward: boolean
  isDesktop: boolean
  isSmall?: boolean
}

const LineHighChart: React.FC<LineHighChartProps> = ({
  data,
  isUpward,
  isDesktop,
  isSmall = false,
}) => {
  const getChartHeight = () => {
    if (isSmall) return 60
    return isDesktop ? 260 : 180
  }

  const getChartWidth = () => {
    if (isSmall) return 120
    return null
  }

  const configPrice = {
    yAxis: [
      {
        offset: 0,
        labels: {
          formatter: function () {
            return ''
          },
          align: 'left',
        },
        gridLineColor: 'transparent',
        title: '',
        opposite: false,
        type: 'logarithmic',
      },
    ],
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      areaspline: {
        fillColor: isSmall
          ? 'transparent'
          : {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: isUpward
                ? [
                    [0, 'rgba(0, 166, 140, 0.41)'],
                    [1, 'rgba(0, 166, 140, 0.00)'],
                  ]
                : [
                    [0, 'rgba(255, 92, 86, 0.41)'],
                    [1, 'rgba(255, 92, 86, 0.00)'],
                  ],
            },
        lineWidth: isSmall ? 2 : 2,
      },
      series: {
        showInNavigator: false,
        gapSize: 6,
        color: isUpward ? '#00A68C' : '#ff5c56',
        marker: {
          symbol: 'circle',
          enabled: false,
        },
      },
    },
    title: {
      text: '',
      style: {
        color: 'white',
      },
      align: 'left',
    },
    chart: {
      height: getChartHeight(),
      width: getChartWidth(),
      backgroundColor: 'transparent',
      tickColor: 'red',
      spacingLeft: 0,
      spacingRight: 0,
      spacingTop: isSmall ? 5 : 10,
      spacingBottom: isSmall ? 5 : 10,
      ...(isSmall && {
        marginLeft: 0,
        marginRight: 0,
      }),
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      visible: false,
      type: 'datetime',
      minPadding: 0,
      maxPadding: 0,
    },
    series: [
      {
        name: '',
        type: isSmall ? 'spline' : 'areaspline',
        data: data,
        tooltip: {
          valueDecimals: 2,
          enabled: false,
        },
      },
    ],
    time: {
      useUTC: false,
    },
  }

  return <HighchartsReact highcharts={Highcharts} options={configPrice} />
}

export default LineHighChart
